// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CIFIY23kHNoJ2Usir26g{padding:0}.YpmSs5CEg9MqmdsMUU1y{justify-content:center;align-items:center;width:40px;height:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxCell": `CIFIY23kHNoJ2Usir26g`,
	"wrapCheckbox": `YpmSs5CEg9MqmdsMUU1y`
};
export default ___CSS_LOADER_EXPORT___;
